var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',{style:({width: _vm.width + 'px', height: _vm.height + 'px'}),attrs:{"label-in-value":_vm.labelInValue,"options":_vm.options,"disabled":_vm.disabled,"show-search":_vm.showSearch,"filter-option":_vm.filterOption},on:{"change":_vm.change},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }